const faqs = [
  {
    q: '51每日大赛网站是什么？',
    a: '51每日大赛是一个专注于为每日大赛用户提供最新入口导航的服务平台。我们持续追踪每日大赛官方网站与APP的可用入口，帮助用户解决因网址变更导致的访问问题，确保每一位用户都能顺利进入每日大赛平台。',
  },
  {
    q: '每日大赛APP如何下载安装？',
    a: '您可以通过本站提供的下载入口获取每日大赛APP。iOS用户可在App Store搜索下载，Android用户可通过官方提供的APK安装包进行安装。安装前请确保设备允许安装来自未知来源的应用（仅限Android），并建议从官方渠道获取安装包以确保安全。',
  },
  {
    q: '为什么每日大赛有时无法访问？',
    a: '每日大赛可能因网络波动、域名解析调整或服务器维护等原因出现暂时无法访问的情况。我们的网站会实时监控入口状态，并在第一时间更新最新可用的网址和备用入口。建议您收藏本站，以便随时获取最新访问方式。',
  },
  {
    q: '如何获取每日大赛的最新网址？',
    a: '关注本站「赛事速递」板块和「最新动态」时间线，我们会第一时间发布每日大赛最新网址更新通知。同时建议您下载每日大赛官方APP，移动端通常具有更好的访问稳定性，且支持推送通知提醒功能。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于每日大赛入口与使用的常见问题解答，快速找到您需要的帮助
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid gap-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-7">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}